// extracted by mini-css-extract-plugin
export var alt = "FrequentlyAskedQuestions-module--alt--f09b1";
export var card = "FrequentlyAskedQuestions-module--card--5237f";
export var container = "FrequentlyAskedQuestions-module--container--44d96";
export var desktopOnly = "FrequentlyAskedQuestions-module--desktopOnly--14903";
export var main = "FrequentlyAskedQuestions-module--main--ea69c";
export var mobileOnly = "FrequentlyAskedQuestions-module--mobileOnly--df5ae";
export var questionLabel = "FrequentlyAskedQuestions-module--questionLabel--968b8";
export var styledAccordian = "FrequentlyAskedQuestions-module--styledAccordian--4b63b";
export var styledListGroups = "FrequentlyAskedQuestions-module--styledListGroups--36861";
export var textLeft = "FrequentlyAskedQuestions-module--textLeft--efe3a";
export var visuallyHidden = "FrequentlyAskedQuestions-module--visuallyHidden--e8893";